import client from '@/shared/apis/client'
import {
  IntegrationToken,
  LineThreadDetail,
  LineThreadList,
  LineMessage,
  LineStatus,
} from '@/features/internal/patient-messaging/types/patientMessaging'

// LINE連携状態取得（患者ID指定）
export const getLineStatus = async (patientId: string): Promise<LineStatus> => {
  const response = await client.get(
    `/api/patient-messaging/chat/line/by-patient/${patientId}/`
  )
  return response.data
}

// LINE連携トークン生成
export const createIntegrationToken = async (
  patientId: string
): Promise<IntegrationToken> => {
  const response = await client.post(
    '/api/patient-messaging/integration/line/',
    {
      patient_id: patientId,
    }
  )
  return response.data
}

// やり取りの一覧（back の既定のページ送りで先頭の 1 ページ = 20 件）
export const getThreads = async (): Promise<LineThreadList> => {
  const response = await client.get('/api/patient-messaging/chat/line/')
  return response.data
}

// LINEスレッド詳細取得
export const getThread = async (
  threadId: string
): Promise<LineThreadDetail> => {
  const response = await client.get(
    `/api/patient-messaging/chat/line/${threadId}/`
  )
  return response.data
}

// LINEメッセージ送信
export const sendMessage = async (
  threadId: string,
  content: string
): Promise<LineMessage> => {
  const response = await client.post(
    `/api/patient-messaging/chat/line/${threadId}/messages/`,
    { content }
  )
  return response.data
}
